import React, {
	memo,
	useCallback,
	useMemo,
	useRef
} from 'react';
import { CSSTransition } from 'react-transition-group';
import { Icon } from 'semantic-ui-react';

import { log } from '../../../services/utils';

import {
	useUIState,
	useUIAction
} from '../../../contexts/UIContext';

import styles from './sidebar.module.css';
import SidebarRoutes from './SidebarRoutes';
import Logo from '../../Shared/Logo';

const Sidebar = () => {
	const { sidebar } = useUIState();
	const { setSidebar } = useUIAction();

	const nodeRef = useRef( null );

	const handleSidebarClose = useCallback( () => {
		setSidebar( false );
	}, [ setSidebar ] );

	const sidebarClassNames = useMemo( () => ( {
		enter: styles.sidebarEnter,
		enterActive: styles.sidebarEnterActive,
		enterDone: styles.sidebarEnterDone,
		exit: styles.sidebarExit,
		exitActive: styles.sidebarExitActive,
		exitDone: styles.sidebarExitDone
	} ), [] );

	return (
		<>
			{ log( 'sidebar' )}
			<CSSTransition
				classNames={ sidebarClassNames }
				in={ sidebar }
				nodeRef={ nodeRef }
				key="sidebar"
				timeout={ 0 }
			>
				<div
					className={ `${ styles.sidebar } no-print` }
					ref={ nodeRef }
				>
					<Icon
						className={ styles.sidebarToggleClose }
						link
						name="close"
						onClick={ handleSidebarClose }
						size="big"
					/>

					<Logo className={ styles.logo } />
					<SidebarRoutes />
				</div>
			</CSSTransition>
		</>
	);
};

export default memo( Sidebar );
